module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dark pad-1"
  }, [_c('div', {
    staticClass: "page-header marg-1-bottom"
  }, [_c('h2', [_vm._v("Ansættelser")]), _vm._v(" "), (_vm.isOrganisationsEnabled) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isOrganisationsModal = true
      }
    }
  }, [_vm._v("\n      Organisationer\n    ")]) : _vm._e()]), _vm._v(" "), _c('SalarySettingsUsersOpus', {
    attrs: {
      "isSalaryIntegrationActive": true,
      "users": _vm.usersWithEmployments,
      "employments": _vm.employments,
      "tags": _vm.tags,
      "isShowEmploymentNumber": true,
      "confirmRemoveTemplateOnTagClick": true,
      "filtersStorageKey": "tjenestenumreFilters",
      "rowActionLabel": "Indtast tjenestenummer",
      "emitEditSsn": true
    },
    on: {
      "setTheEditUser": _vm.openImport,
      "editSsn": _vm.openImport
    }
  }), _vm._v(" "), (_vm.theImportUser) ? _c('EmploymentImportModal', {
    attrs: {
      "user": _vm.theImportUser,
      "numberLabel": "Tjenestenummer",
      "maxLength": 5
    },
    on: {
      "close": function($event) {
        _vm.theImportUser = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOrganisationsModal) ? _c('SalaryOrganisationsModal', {
    on: {
      "close": function($event) {
        _vm.isOrganisationsModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06500c9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/Tjenestenumre.vue
// module id = 1741
// module chunks = 1